<template>
  <v-app>
    <v-main class="restore-form-bg">
      <v-container fluid class="fill-height">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="8" lg="6">
            <v-card elevation="4" class="restore-form-card">
              <v-container>
                <h1 class="mb-2 grey--text text--darken-3 d-none d-md-flex">Восстановление пароля</h1>
                <!-- Для десктопа -->
                <h3 class="mb-2 grey--text text--darken-3 d-md-none d-flex">Восстановление пароля</h3>
                <!-- Для мобилки -->
                <div>
                  Пароль будет сброшен для пользователя: <b>{{ user_name }}</b><br>
                </div>
              </v-container>
              <v-card-actions>
                <v-btn color="primary" block @click="resetPassword">
                  <v-icon class="mr-1">mdi-lock-reset</v-icon> Сбросить пароль и отправить на e-mail
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
export default {
  props: {
    user_name: String,
    token: String,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {},
  methods: {
    async resetPassword() {
      try {
        const confirm = await Client.msg.confirm(
          "Пароль будет сброшен",
          "Продолжить?"
        );
        if (!confirm.isConfirmed) {
          return;
        }
        this.loading = true;
        const result = await Client.request.post({
          url: `/genandsendpwd`,
          data: {
            token: this.token,
          },
        });
        this.loading = false;
        if (result == "OK") {
          Client.msg.success("Новый пароль отправлен, проверьте почту.");
        }
      } catch (err) {
        this.loading = false;
        console.error(err);
      }
    },
  },
};
</script>
